<template>
  <sales-charges-module v-if="chargesNewLayoutEnabled" />
  <div v-else>
    <new-filter
      v-if="showFilter"
      ref="newFilter"
      :options="filterOptions"
      :additionalOptions="additionalOptions"
      :loadingList="loadingList"
      :action="action"
      origin="charges"
      :sendFilterEvents="sendEvents"
      @setTabbar="paymentSelected"
      :eventProps="filterEvent"
    />

    <emd-alert
      v-if="report.alert.show"
      :variant="report.alert.variant"
      @cancel="report.alert.show = false"
    >
      <template slot="content">
        <p>{{ $t(report.alert.title) }}</p>
      </template>
    </emd-alert>
    <div class="el-chunk">
      <div>
        <tabbar-payment-method
          :paymentMethod="additionalOptions.payment_methods"
          @paymentSelected="paymentSelected"
        />
      </div>
      <emd-card
        noBorder
        class="_footer_spaced_sm"
      >
        <emd-card-header>
          <h2 class="emd-text _size_section">{{ $t('charges.list') }}</h2>

          <template slot="actions">
            <report-button
              :loadingList="loadingList"
              :report="report"
              :totalListItems="totalItems"
              :eventProps="{
                amplitudeInstance: 'chargesEvents',
                eventFunctionName: 'exportDataClicked'
              }"
            />
          </template>
        </emd-card-header>
        <emd-card-content customClass="eu-no-padding">
          <div
            v-if="loadingList"
            class="eu-pa_6 eu-align_center"
          >
            <emd-loader :type="'_invert'"></emd-loader>
          </div>
          <div
            v-else
            class="emd-table-responsive"
          >
            <Table
              :fields="fields"
              :items="charges.items"
              :toDetail="permissionIsEnabled('charge:get') && toDetail"
              :eventProps="tableEvents"
            ></Table>
            <empty-list
              v-if="showEmptyList()"
              entity="charges"
            ></empty-list>
            <empty-list-filter
              v-if="showEmptyListFilter()"
              entity="charges"
            ></empty-list-filter>
          </div>
          <pagination
            v-if="!loadingList"
            :pagination="charges.pagination"
            :totalShowing="totalPerPageItems"
            :type="'list'"
            :action="action"
          ></pagination>
        </emd-card-content>
      </emd-card>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  EmdLoader,
  EmdAlert,
  EmdCard,
  EmdCardContent,
  EmdCardHeader
} from 'emerald-vue/src/components'
import '@pagarme/sales-charges/web-comp'

import { chargesEvents as Amplitude } from '@/amplitude-events/sales.amplitude'
import NewFilter from '@/components/project/globals/Filter/NewFilter.vue'
import EmptyList from '@/components/project/globals/EmptyList.vue'
import EmptyListFilter from '@/components/project/globals/EmptyListFilter.vue'
import Table from '@/components/project/molecules/Table.vue'
import Pagination from '@/components/project/globals/Pagination.vue'
import ReportButton from '@/components/project/molecules/ReportButton.vue'

import TabbarPaymentMethod from '@/views/Payments/Charges/TabbarPaymentMethod'

import PaymentSearchMixin from '../paymentSearch.mixin'
import { isSalesNewLayoutFlagEnabled } from '../../../feature-flags/sales.feature-flags'

export default {
  components: {
    NewFilter,
    EmdLoader,
    EmdCard,
    EmdCardContent,
    EmdCardHeader,
    EmptyList,
    EmptyListFilter,
    Table,
    Pagination,
    EmdAlert,
    TabbarPaymentMethod,
    ReportButton
  },
  mixins: [PaymentSearchMixin],
  data () {
    return {
      isSalesNewLayoutFlagEnabled: false,
      action: 'GET_CHARGES',
      toDetail: {
        name: 'chargesDetail',
        params: {
          id: 'id'
        },
        query: ['created_at']
      },
      sendEvents: true,
      report: {
        action: 'SEND_CHARGE_REPORT_FILE',
        loading: false,
        alert: {
          show: false
        },
        queryArray: [
          'ids',
          'codes',
          'payment_methods',
          'customer_ids',
          'order_ids',
          'invoice_ids',
          'tids',
          'nsus',
          'brands',
          'acquirers',
          'nosso_numeros',
          'banks',
          'status',
          'transaction_status',
          'funding_source'
        ]
      },
      exportLoading: false,
      closeWarning: false,
      additionalOptions: {
        payment_methods: null,
        sort_mode: 'desc'
      }
    }
  },
  computed: {
    ...mapGetters([
      'filterOptionsCharges',
      'loadingListCharges',
      'charges',
      'permissionIsEnabled',
      'accountId',
      'merchantId',
      'isEmployee',
      'pagarmeCompanyId'
    ]),
    chargesNewLayoutEnabled () {
      return true
    },
    showFilter () {
      return this.permissionIsEnabled('charge:search')
    },
    filterEvent () {
      return {
        amplitudeInstance: 'chargesEvents',
        eventFunctionName: 'refreshListClicked'
      }
    },
    tableEvents () {
      return {
        amplitudeInstance: 'chargesEvents',
        id: {
          feature: 'actions',
          eventFunctionName: 'chargeDetailsButtonClicked'
        },
        details: {
          feature: 'actions',
          eventFunctionName: 'chargeDetailsButtonClicked'
        }
      }
    },
    fields () {
      return [
        {
          id: 'id',
          label: 'charge.list.id',
          type: this.permissionIsEnabled('charge:get') ? 'link' : 'text',
          link: {
            to: 'chargesDetail',
            params: { id: 'id' },
            query: ['created_at']
          }
        },
        {
          id: 'code',
          label: 'charge.list.code',
          type: 'text'
        },
        {
          id: 'customer_name',
          label: 'charge.list.customer',
          type: 'text'
        },
        {
          id: 'amount',
          label: 'charge.list.amount',
          type: 'text'
        },
        {
          id: 'status',
          label: 'charge.list.status',
          type: 'status'
        },
        {
          id: 'last_transaction_status',
          label: 'charge.list.last-transaction',
          type: 'text'
        },
        {
          id: 'payment_method',
          label: 'charge.list.payment-method',
          type: 'text'
        },
        {
          id: 'created_at',
          label: 'charge.list.created-at',
          type: 'date',
          format: 'dateAndHour'
        }
      ]
    },
    filterOptions () {
      return this.filterOptionsCharges
    },
    loadingList () {
      return this.loadingListCharges
    },
    totalPerPageItems () {
      return this.charges.items.length
    },
    totalItems () {
      return this.charges.pagination.total_items
    }
  },

  async mounted () {
    this.$nextTick(() => Amplitude.events.view.loadView(this.$route.query))

    this.isSalesNewLayoutFlagEnabled = await isSalesNewLayoutFlagEnabled()

    this.report = {
      ...this.report,
      enabled: this.permissionIsEnabled('charge.report:export')
    }
  },

  methods: {
    getRouteQueryEmptyListCount () {
      const routeQuery = this.$route.query
      return Object.keys(routeQuery).length
    },
    showEmptyListDefault () {
      return (
        !this.loadingList &&
        this.charges.pagination &&
        this.charges.pagination.total_items === 0
      )
    },
    showEmptyList () {
      return (
        this.showEmptyListDefault() && this.getRouteQueryEmptyListCount() <= 4
      )
    },
    showEmptyListFilter () {
      return (
        this.showEmptyListDefault() && this.getRouteQueryEmptyListCount() > 4
      )
    },
    paymentSelected (paymentMethod) {
      this.additionalOptions.payment_methods = paymentMethod
      this.$refs.newFilter.search()
      if (this.$gtag && !this.isEmployee) {
        this.$gtag.event('add-filter-tab', {
          event_category: 'charges-list-filter',
          event_label: `tab_filter-${paymentMethod}`
        })
      }
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "title": "Cobranças",
    "warning": "O período para a exibição de itens na listagem de Cobranças, sem a aplicação de filtros, é de 30 dias.",
    "id": "ID",
    "customer": "Cliente",
    "code": "Código",
    "amount": "Valor",
    "status": "Status",
    "last-transaction": "Última transação",
    "payment-method": "Forma de pagamento",
    "created-at": "Criado em",
    "report.success": "Em breve você receberá um e-mail com o link para download do arquivo.",
    "report.error": "Houve um erro no envio da sua requisição. Tente novamente mais tarde.",
    "report.limit": "Opa! Sua solicitação ultrapassou o nosso limite de 150.000 itens. Use o filtro para obter resultados mais objetivos e exporte novamente.",
    "charges.list": "Lista de cobranças"
  },
  "en-US": {
    "title": "Charges",
    "warning": "The range of Charge list, without filter, is 30 days.",
    "id": "ID",
    "customer": "Customer",
    "code": "Code",
    "amount": "Amount",
    "status": "Status",
    "last-transaction": "Last transaction",
    "payment-method": "Payment method",
    "created-at": "Created",
    "report.success": "Soon you will receive an email with the file download link.",
    "report.error": "There was an error sending your request. Try again later.",
    "report.limit": "Oops! Your request has exceeded our 70.000 items limit. Use the filter to get more objective results and export again.",
    "charges.list": "Charges list"
  }
}
</i18n>
